export default __webpack_public_path__ + "static/media/mallory_mp_compact_black.effb9594.ttf";